import { VerticalContainer } from '@american-autonomy/ag-ui';

import InputLabelText from 'components/text/InputLabelText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WithField: FunctionComponent<Props> = ({
    children,
    className = '',
    label,
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${className} ${styles.withField}`} testId={testId}>
        <VerticalContainer className={styles.flex}>
            <InputLabelText text={label} />
        </VerticalContainer>

        {children}
    </VerticalContainer>
);

export default WithField;
